// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICustomPageContributionAuditResponse,
} from '../models/index';
import {
    ICustomPageContributionAuditResponseFromJSON,
    ICustomPageContributionAuditResponseToJSON,
} from '../models/index';

export interface GetContributionRequestChangesetsRequest {
    requestId: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

/**
 * ContributionAuditControllerApi - interface
 * 
 * @export
 * @interface ContributionAuditControllerApiInterface
 */
export interface ContributionAuditControllerApiInterface {
    /**
     * 
     * @param {number} requestId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {Array<string>} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionAuditControllerApiInterface
     */
    getContributionRequestChangesetsRaw(requestParameters: GetContributionRequestChangesetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContributionAuditResponse>>;

    /**
     */
    getContributionRequestChangesets(requestParameters: GetContributionRequestChangesetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContributionAuditResponse>;

}

/**
 * 
 */
export class ContributionAuditControllerApi extends runtime.BaseAPI implements ContributionAuditControllerApiInterface {

    /**
     */
    async getContributionRequestChangesetsRaw(requestParameters: GetContributionRequestChangesetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageContributionAuditResponse>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getContributionRequestChangesets().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/audit/contribution-requests/{request_id}/changesets`;
        urlPath = urlPath.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageContributionAuditResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContributionRequestChangesets(requestParameters: GetContributionRequestChangesetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageContributionAuditResponse> {
        const response = await this.getContributionRequestChangesetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
